/**
 * Contact template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import { gsap } from "gsap";
import jQuery from 'jquery';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Contact';

let global = null;

window.jQuery = jQuery; // Required for WPForms

const embedDom = document.querySelector(`[data-embed]`);

const overlayDom = document.querySelector(`[data-overlay]`);
const overlayDomActiveClass = `contact-form__overlay--active`;

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initOverlay();
}

/**
 * initOverlay - Initialize the overlay
 */
const initOverlay = () => {
	Logger.info(`${NAME} > initOverlay`);

	let mm = gsap.matchMedia();

	// add a media query. When it matches, the associated function will run
	mm.add(`(min-width: ${global.breakpoints.laptop_min}px)`, () => {

		if (embedDom && overlayDom) {

			const inputDoms = embedDom.querySelectorAll(`input, textarea`);

			inputDoms.forEach((inputDom) => {
				inputDom.addEventListener(`focus`, () => {
					global.themeHeader.setDisplayMode(`transparentWhite`);
					overlayDom.classList.add(overlayDomActiveClass);
				});

				inputDom.addEventListener(`blur`, () => {
					global.themeHeader.setDisplayMode(`normal`);
					overlayDom.classList.remove(overlayDomActiveClass);
				});
			});
		}

	});
}

// Bootstrap global functionality
global = Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
